import { render, staticRenderFns } from "./download-button.vue?vue&type=template&id=b92dacc0"
import script from "./download-button.vue?vue&type=script&lang=ts"
export * from "./download-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports